<template>
  <div class="about-box">
    <div class="container">
      <AnimeTitle
        :title="$t('about.title')"
        svgRefValue="aboutAnimeTitle"
        :computingTitle="$t('about.computingTitle')"
      />
      <div
        data-animation="fade-scale-up"
        data-once="false"
        class="secondary-title"
      >
        {{ $t('about.subTitle') }}
      </div>
      <p
        class="about-description"
        data-animation="fade-scale-up"
        data-once="false"
      >
        {{ $t('about.description') }}
      </p>
      <p data-animation="fade-scale-up" data-once="false">
        {{ $t('about.description1') }}
      </p>
      <!-- <div
        class="about-user-name"
        data-animation="fade-scale-up"
        data-once="false"
        v-if="currentLocale === 'en'"
      >
        {{ $t('about.name1') }}
      </div> -->
      <p data-animation="fade-scale-up" data-once="false">
        {{ $t('about.description2') }}
      </p>
      <!-- <div
        class="about-user-name"
        data-animation="fade-scale-up"
        data-once="false"
        v-if="currentLocale === 'en'"
      >
        {{ $t('about.name2') }}
      </div> -->
      <p data-animation="fade-scale-up" data-once="false">
        {{ $t('about.description3') }}
      </p>
      <p data-animation="fade-scale-up" data-once="false">
        {{ $t('about.description4') }}
      </p>
      <p
        data-animation="fade-scale-up"
        data-once="false"
        v-if="currentLocale === 'en'"
      >
        {{ $t('about.description5') }}
      </p>
    </div>
    <video
      src="https://img.aikesaisi.com/lkzh/www/introduce.mp4"
      preload="auto"
      muted
      autoplay
      data-animation="fade-scale-up"
      data-once="false"
      loop
      class="about-company"
    />
  </div>
</template>
<script setup></script>
<style lang="scss" scoped>
.about-box {
  padding: 120px 0 0px 0;
  text-align: center;
  p {
    color: #222226;
    text-align: left;
    font-size: 16px;
    font-family: 'MiSans-Regular';
    line-height: 30px;
  }
  .about-description {
    font-size: 20px;
    margin-top: 60px;
    font-family: 'MiSans-Medium';
  }
  .about-company {
    width: 100%;
    margin-top: 60px;
    object-fit: cover;
    height: 600px;
  }
}
</style>
